import React from 'react'
import { Link } from 'react-router-dom'

const projectsList = [
    {
        name: 'Security Services Website',
        picture: '/images/ValourSecurity.png',
        alt: '',
        desc: 'A website built for a Security Company. Purposed for increased company exposure.',
        attr1: 'react',
        attr2: 'web design',
        attr3: 'tailwind css',
        link: 'https://syedimadahmed.com',
        github: 'https://www.github.com/imadahmed101',
    },
    {
        name: 'Handyman/Contractor Website',
        picture: '/images/contracting.png',
        alt: '',
        desc: 'Website for a Handyman/General Contractor. Purposed for increased company exposure.',
        attr1: 'react',
        attr2: 'web design',
        attr3: 'tailwind css',
        link: 'https://oreilly-custom-contracting.syedimadahmed.com/',
        github: 'https://www.github.com/imadahmed101',
    },
    {
        name: 'Workout Tracker',
        picture: '/images/waitlift.png',
        alt: '',
        desc: 'Application built to help you monitor and track your workouts.',
        attr1: 'react',
        attr2: 'user experience',
        attr3: 'app design',
        link: 'https://waitlift.syedimadahmed.com/',
        github: 'https://www.github.com/imadahmed101/waitlift',
    },
    {
        name: 'Insurance Agency Website',
        picture: '/images/wmi-tag.png',
        alt: 'Willis and Monroe Associates insurance agency project',
        desc: 'A website built for an insurance agency. Purposed for increased company exposure.',
        attr1: 'react',
        attr2: 'web design',
        attr3: 'hosting/domain',
        link: 'https://willismonroeinsurance.com',
        github: 'https://www.github.com/imadahmed101/willismonroeinsurance',
    },
    {
        name: 'Web Forum Website',
        picture: '/images/sitefix-tag.png',
        alt: '',
        desc: 'Application built around a site fixing platform.',
        attr1: 'react',
        attr2: 'web design',
        attr3: 'tailwind css',
        link: 'https://oreilly-custom-contracting.syedimadahmed.com/',
        github: 'https://www.github.com/imadahmed101',
    },
    {
        name: 'Social Media Manager Website',
        picture: '/images/trendily-tag.png',
        alt: '',
        desc: 'Application built to help you monitor and track your workouts.',
        attr1: 'react',
        attr2: 'user experience',
        attr3: 'app design',
        link: 'https://waitlift.syedimadahmed.com/',
        github: 'https://www.github.com/imadahmed101/waitlift',
    },
    {
        name: 'Cloud Native Full Stack App',
        picture: '/images/cloud1.svg',
        alt: '',
        desc: 'A full-stack cloud-native app built with secure authentication via Entra ID, React front-end, and a scalable Node.js back-end using Cosmos DB.',
        attr1: 'cloud native',
        attr2: 'full stack',
        attr3: 'azure',
        link: '/',
        github: 'https://github.com/imadahmed101/student-portal-azure-cloudnative',
    },
    {
        name: 'Serverless Function App',
        picture: '/images/cloud1.svg',
        alt: '',
        desc: 'A serverless workout tracker built with Azure Functions, integrating blob/table/queue storage and automated reminders.',
        attr1: 'azure',
        attr2: 'function app',
        attr3: 'serverless',
        link: 'https://waitlift.syedimadahmed.com/',
        github: 'https://github.com/imadahmed101/workout-tracker-azure-serverless',
    },
    {
        name: 'Infrastructure as Code',
        picture: '/images/cloud1.svg',
        alt: '',
        desc: 'Automated deployment of web app infrastructure using Azure Bicep templates and CLI for a consistent, production-ready environment.',
        attr1: 'azure',
        attr2: 'bicep',
        attr3: 'cli',
        link: 'https://waitlift.syedimadahmed.com/',
        github: 'https://github.com/imadahmed101/webapp-iac-azure-bicep',
    }



]

const Projects = () => {
    return (
        <div className='pt-8 bg-black/10'>



                <h3 className='text-center font-semibold text-3xl mb-4'>Projects</h3>
            <div className='overflow-x-auto py-6'>
                <div className='flex flex-row flex-nowrap space-x-4 w-max'>

                    {projectsList.map((item, key) => (
                        <div key={key} className='flex flex-col w-[350px] md:w-[500px] bg-white justify-between h-full rounded-lg  p-5 shadow-lg'>
                            <img
                                src={item.picture}
                                alt={item.alt}
                                className="rounded-md mb-4 h-60 w-full object-cover"
                            />
                            <h3 className="text-xl font-semibold mb-2">{item.name}</h3>
                            

                        </div>

                    ))}

                </div>
            </div>
        </div>

    )
}

export default Projects